import { styled as g } from "@mui/material";
import y from "../../../assets/icons/icon-blank.svg.js";
import _ from "../generic/AnimatedBox.js";
import { DEFAULT_ANIMATE_DURATION as j, DEFAULT_ALT as z } from "../../../constants/layout.js";
import B from "next/image";
import { useState as a, useCallback as o, useEffect as C } from "react";
import { jsx as v } from "react/jsx-runtime";
const F = g(B)`
  object-fit: contain;
`, H = g(_)`
  position: relative;
`, R = (s) => {
  var t;
  return ((t = s == null ? void 0 : s.src) == null ? void 0 : t.indexOf("data:image/gif;base64")) < 0;
}, Q = (s) => {
  const {
    alt: t = z,
    className: w,
    extraSrc: e,
    fallbackUrl: c = y,
    isDisable: m,
    loading: L = void 0,
    src: i,
    onAnimationEnd: E,
    ...r
  } = s, [I, n] = a(i), [f, u] = a(!1), [h, p] = a(!1), [O, b] = a(!0), A = o(() => {
    u(!0);
  }, []), D = o(() => {
    u(!1);
  }, []), M = o(() => {
    p(!0);
  }, []), k = o(() => {
    p(!1);
  }, []), x = o((l) => {
    const {
      src: d,
      width: N
    } = l;
    return `${d}?w=${N}`;
  }, []), P = o(() => {
    n(c);
  }, [c]), T = o((l) => {
    const d = l.target;
    R(d) && b(!0);
  }, []), U = {
    ...e != null && e.hover ? {
      onMouseEnter: A,
      onMouseLeave: D
    } : {},
    ...e != null && e.pressed ? {
      onMouseDown: M,
      onMouseUp: k
    } : {}
  };
  return C(() => {
    e ? e.disable && m ? n(e.disable) : e.hover && f ? n(e.hover) : e.pressed && h && n(e.pressed) : n(i);
  }, [e, m, f, h, i]), /* @__PURE__ */ v(H, {
    className: w,
    in: O,
    timeout: j,
    onAnimationEnd: E,
    ...U,
    children: /* @__PURE__ */ v(F, {
      alt: t,
      fill: r.width == null && r.height == null,
      loading: L ? "lazy" : void 0,
      sizes: "(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 100vw",
      src: I || "",
      loader: x,
      onError: P,
      onLoad: T,
      ...r
    })
  });
};
export {
  Q as default
};
//# sourceMappingURL=Image.js.map
